module.exports = __webpack_public_path__ + "static/img/habilidades psico.3d811ce3.png";